а<template>
    <ValidationObserver ref="form">
        <div class="row">
            <div class="col-lg-12 mb-4" ref="form">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">My Profile</div>
                        </div>
                        <div class="my-profile-block">
                            <div class="avatar-block">
                                <div class="user-link">
                                    <div class="avatar"
                                         :style="{'background-image': avatar ? getNameOfAvatar(avatar) : 'url(/img/svg/emptyAvatar.png)'}"
                                    >
                                        <a href="javascript:void(0)" class="photo-edit">
                                            <img src="/img/svg/icons-pen-white.svg"
                                                 @click="$refs.imageInput.click()"
                                                 class="icon"
                                                 alt="">
                                        </a>
                                        <input
                                            type="file"
                                            style="display: none"
                                            @change="onImageSelected"
                                            ref="imageInput"
                                            accept="image/*"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="my-info-block">
                                <div class="row">
                                    <ValidationProvider
                                        class="col-md-6"
                                        name="First Name"
                                        rules="required|latin|min:2|max:100"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">First Name</label>
                                            <input type="text" class="form-control" v-model="profile.name">
                                            <FormError :error="errors[0]" name="First Name"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-6"
                                        name="Last Name"
                                        rules="required|latin|min:2|max:100"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Last Name</label>
                                            <input type="text" class="form-control" v-model="profile.last_name">
                                            <FormError :error="errors[0]" name="Last Name"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-6"
                                        name="Phone number"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Phone Number </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-mask="'+1 (###) ###-####'"
                                                v-model="profile.cell_number"
                                            >
                                            <FormError :error="errors[0]"  name="Phone number"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-6"
                                        name="Email"
                                        rules="required|email"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Email Address</label>
                                            <input type="email" class="form-control" v-model="profile.email">
                                            <FormError :error="errors[0]" name="Email"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-6"
                                        name="password"
                                        rules=""
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Password</label>
                                            <input type="password" class="form-control" v-model="profile.password_confirmation">
                                            <FormError :error="errors[0]" name="password"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-6"
                                        name="conf password"
                                        rules="confirmed:password"
                                        v-slot="{ errors }"

                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Confirm New Password</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                v-model="confirmPassword"
                                                data-vv-as="password"
                                            >
                                            <FormError :error="errors[0]" name="conf password"></FormError>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <div class="form mt-3">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="table-holder table-responsive ">
                                        <table class="table shifts-table">
                                            <thead>
                                            <tr>
                                                <th>Notification</th>
                                                <th class="text-center">Text</th>
                                                <th class="text-center">Email</th>
                                                <th class="text-center">On Platform</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="item in listOfNotifications"
                                                :key="item.id"
                                            >
                                                <td>{{item.notification_item.script}}</td>
                                                <td class="text-center">
                                                    <div class="centred-checkbox">
                                                        <div class="form-group form-group-1">
                                                            <div class="form-check">
                                                                <input
                                                                    class="form-check-input-checkbox"
                                                                    type="checkbox"
                                                                    id="home-office"
                                                                    v-model="item.byText"
                                                                >
                                                                <label class="form-check-label" for="home-office"></label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </td>
                                                <td class="text-center">
                                                    <div class="centred-checkbox">
                                                        <div class="form-group form-group-1">
                                                            <div class="form-check">
                                                                <input
                                                                    class="form-check-input-checkbox"
                                                                    type="checkbox"
                                                                    id="home-office"
                                                                    v-model="item.byEmail"
                                                                >
                                                                <label class="form-check-label" for="home-office"></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="centred-checkbox">
                                                        <div class="form-group form-group-1">
                                                            <div class="form-check">
                                                                <input
                                                                    class="form-check-input-checkbox"
                                                                    type="checkbox"
                                                                    id="home-office"
                                                                    v-model="item.onPlatform"
                                                                >
                                                                <label class="form-check-label" for="home-office"></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="btns-wrap">
                                        <a href="javascript:void(0)"
                                           class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                        <a href="javascript:void(0)" @click="validateAndSave"
                                           class="btn btn--secondary w-100 w-sm-auto">Proceed</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>

import ProfileServices from "./services/ProfileServices";
import ApplicantsServices from "../../../Applicants/resources/js/services/ApplicantsServices";
import UsersServices from "../../../Users/resources/js/services/UsersServices";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'Profile',
    mixins: [StyleHandler],
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            profile: this.user ?? {},
            selectedFile: null,
            confirmPassword: null,
            avatar: this.user.avatar,
            listOfNotifications: [],
            form: {}
        }
    },
    methods: {
        async getListOfUserNotifications() {
            try {
                const {data: response} = await UsersServices.getListOfNotifications(this.user.id)
                this.listOfNotifications = response
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        async uploadPhoto() {
            if (this.selectedFile) {
                this.$showLoadingMessage()
                let formData = new FormData();
                formData.append('photo', this.selectedFile);
                try {
                    const response = await ApplicantsServices.uploadPhoto(this.user.id, formData);
                    this.avatar = response.data.url
                    this.$showSuccessMessage('The avatar was updated')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The photo was not uploaded");
                }
            } else {
                this.$showErrorMessage("Please select photo");
            }
        },
        async validateAndSave() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.updateUserInfo()
        },
        async updateUserInfo() {
            this.$showLoadingMessage()
            this.form = {
                ...this.profile,
                password: this.confirmPassword,
                listOfNotifications: this.listOfNotifications
            }
            try {
                await ProfileServices.updateAdminInfo(this.user.id, this.form)
                this.$showSuccessMessage('The information has been updated')
                setTimeout(()=> {

                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The information was not updated. Server Error')
            }
        },
    },
    mounted() {
        this.getListOfUserNotifications()
    }


}

</script>

<style scoped>

</style>
